import { createAction } from '@reduxjs/toolkit';
import {
  DownloadFileIndexPayload,
  DownloadFileProgressPayload,
  DownloadFileStartPayload,
  DownloadStartPayload,
} from './models';

/**
 * A batch was accepted and is about to start. Every file lands as `queued`;
 * `downloadFilesToDisk` promotes them as it picks them up. Batches accumulate
 * rather than replacing one another — a second download started while the first
 * is still running is a separate transfer to a separate folder, and both have to
 * be reported (VE-26426).
 */
export const DOWNLOAD_SESSION_START = createAction<DownloadStartPayload>(
  'DOWNLOADS/SESSION_START'
);

/** Drop every batch that has nothing left running — the tray's Clear button. */
export const CLEAR_FINISHED_DOWNLOADS = createAction(
  'DOWNLOADS/CLEAR_FINISHED'
);

export const DOWNLOAD_FILE_START = createAction<DownloadFileStartPayload>(
  'DOWNLOADS/FILE_START'
);

export const DOWNLOAD_FILE_PROGRESS = createAction<DownloadFileProgressPayload>(
  'DOWNLOADS/FILE_PROGRESS'
);

export const DOWNLOAD_FILE_DONE = createAction<DownloadFileIndexPayload>(
  'DOWNLOADS/FILE_DONE'
);

export const DOWNLOAD_FILE_ERROR = createAction<DownloadFileIndexPayload>(
  'DOWNLOADS/FILE_ERROR'
);

export const TOGGLE_DOWNLOAD_TRAY = createAction('DOWNLOADS/TOGGLE_TRAY');

export const CLOSE_DOWNLOAD_TRAY = createAction('DOWNLOADS/CLOSE_TRAY');
